(function() {
  'use strict';

  function PlaceholdersCard(RouterHelper, EmailTypes, Notify) {
    return {
      restrict: 'A',
      templateUrl: 'app/components/email-templates/cards/placeholders.html',
      link: function(scope) {
        scope.placeholders = [];
        var emailTypeId = RouterHelper.getParams().emailTypeId;

        EmailTypes.find(emailTypeId)
          .then(function(emailType) {
            if (emailType.placeholders.length > 0) {
              scope.placeholders = emailType.placeholders;
            }
          })
          .catch(Notify.error);
      }
    };
  }

  PlaceholdersCard.$inject = ['RouterHelperService', 'EmailTypesService', 'NotifyService'];

  angular.module('component.emailTemplates')
    .directive('sidebarPlaceholders', PlaceholdersCard);
})();
